import { render, staticRenderFns } from "./PlanForm.vue?vue&type=template&id=a23ea3e0&scoped=true&"
import script from "./PlanForm.vue?vue&type=script&lang=js&"
export * from "./PlanForm.vue?vue&type=script&lang=js&"
import style0 from "./PlanForm.vue?vue&type=style&index=0&id=a23ea3e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a23ea3e0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VContainer,VSwitch,VTextField})
